/** Where a click came from, as one line: country code, region, city — the
 * parts the edge knew, in that order ("MD, Chișinău Municipality, Chisinau").
 * Empty when it knew none. */
export function clickGeo(click: { country?: string; region?: string; city?: string }): string {
  return [click.country, click.region, click.city].filter(Boolean).join(", ");
}
